import { useEffect, useState } from 'react';
import {
  gql,
  useLazyQuery,
  useMutation,
  useQuery
} from '@apollo/client';
import { getUrlParams } from '../domain/domain';
import { useLocation } from '../location/location';
import { isServer } from '../device_detection/device_detection';
import { triggerDatacaptureEventOnMutationResponse, handleResponse } from '../responseHandler/responseHandler';
const { CLIENT_PREVIEWDATE_HEADER, CLIENT_STAGING_HOST_HEADER } = require( '../constants/constants' ).default;
import { useUserContext } from '../../views/__core/UserContextProvider/UserContextProvider';

/**
 * This ia hook to invoke the DXL queries, and takes care of common logic
 * which needs to executed for all DXL requests
 *
 * @method
 * @param { Object } query - this represents the dxl query
 * @param { Object } config - this represents the config details for the query
 * @returns useDXLQuery
 */

export const useDXLQuery = ( query, config = {}, isLazy = false ) => {
  const user = useUserContext();
  const [loginStatus, setLoginStatus] = useState( undefined );
  useEffect( ()=>{
    if( user?.loginType !== loginStatus ){
      setLoginStatus( user?.loginType )
    }
  }, [user?.loginType] );

  const isMutation = query.substring( 0, 10 ).includes( 'mutation' );
  const queryType = isMutation ? useMutation : isLazy ? useLazyQuery : useQuery;
  const newQuery = gql`${query}`;
  const fetchPolicy = query.includes( 'NonCachedPage' ) ? 'no-cache' : config.fetchPolicy || 'cache-first';
  const isPageQuery = query.includes( 'query Page(' );
  const headers = GetHeaders( isPageQuery );

  const variables = {
    ...config.variables,
    ...( !isPageQuery && loginStatus && {
      moduleParams:{
        ...config.variables?.moduleParams,
        loginStatus
      }
    } )
  }

  const response = queryType( newQuery, {
    ...config,
    ...( !isMutation && { fetchPolicy } ),
    variables,
    ...( Object.keys( headers ).length &&
        {
          context: {
            headers
          }
        }
    )
  } );

  // response for mutation is an array and reponse will be in the first index
  const data = Array.isArray( response ) && response.length > 1 ? response[1].data : response?.data

  useEffect( ()=>{
    if( data?.Page?.meta?.dataCaptureEventList ){
      triggerDatacaptureEventOnMutationResponse( data?.Page?.meta?.dataCaptureEventList )
    }
  }, [data?.Page?.meta?.dataCaptureEventList] );

  handleResponse( response );
  return response;
}

export const GetHeaders = ( isPageQuery ) => {

  let stagingHost;
  let previewDate;

  const location = useLocation();
  const urlParams = getUrlParams( location.search );

  stagingHost = urlParams.stagingHost;

  if( isPreviewEnabled( location.hostname ) ){

    previewDate = urlParams.previewDate;

    if( !stagingHost && !isServer() ){
      let previewDateElem = document.getElementById( 'previewDate' );
      let stagingHostElem = document.getElementById( 'stagingHost' );

      if( previewDateElem && stagingHostElem ){
        previewDate = previewDateElem.value;
        stagingHost = stagingHostElem.value;
      }
    }
  }
  return {
    ...( previewDate && { [ CLIENT_PREVIEWDATE_HEADER ]:previewDate } ),
    ...( stagingHost && { [ CLIENT_STAGING_HOST_HEADER ]:stagingHost } ),
    ...( !isServer() && localStorage.getItem( 'sessionData' ) && { 'X-ULTA-DYN-SESSION-CONFIG': JSON.parse( localStorage.getItem( 'sessionData' ) )?.secureToken } ),
    // setting the cacheable header for page query whem it is not server | preview mode | staging host
    ...( isPageQuery && !isServer() && !previewDate && !stagingHost && { 'X-ULTA-GRAPH-TYPE': 'page' } )

  }
}
/**
 * Returns a boolean to indicate if the hostname passed in is a staging environment
 *
 * @method
 * @param { Object } hostname - the hostname
 */
export const isPreviewEnabled =  hostname => {
  return ( /staging.*\.ulta\.com/ ).test( hostname );
}